import { trackClientEvent } from '../../../../../trackClientEvent';
export const eventKey = 'retailer_team_management-invite_team_member_dropdown_item-click';
/**
 * Click event for invite team member dropdown item
 */
export function trackRetailerTeamManagementInviteTeamMemberDropdownItemClick(customParameterToken) {
    return trackClientEvent({
        eventKey,
        realTimeTracking: false,
        parameters: { customParameterToken },
    });
}
